export interface EmailSetting {
  id: number;
  name: string;
  username?: string,
  password?: string,
  auth_by_user?: boolean,
  sys_email_provider?: number,

  email_provider?: EmailProvider,
}

export interface EmailProvider {
    id: number;
    name: string;
    smtp_server: string;
    smtp_port: number;
    encryption_method?: string,
}

export interface SendEmailInfo {
  smtp_port?: number;
  smtp_host?: string;
  sender_email?: string;
  sender_password?: string;
  recipient_email: string,
  email_subject: string,
  email_body: string,

  email_setting_id?: number;
  emailSetting?: EmailSetting,
}

export const newEmailSetting = (): EmailSetting => {
  return {
    id: 0,
    name: "",
  }
};

export const newEmailProvider = (): EmailProvider => {
  return {
    id: 0,
    name: "",
    smtp_port: 0,
    smtp_server: "",
    encryption_method: "",
  }
};

export const newSendEmailInfo = (): SendEmailInfo => {
  return{
    recipient_email: "",
    email_subject: "",
    email_body: "",
  }
};